export const GET_ALL_ACTIVE_PRODUCT = "GET_ALL_ACTIVE_PRODUCT"
export const PRODUCT_INFO_STORE = "PRODUCT_INFO_STORE"
export const STORE_SINGLE_RECODE = "STORE_SINGLE_RECODE"
export const RESET_STATE = "RESET_STATE"
export const GET_ALL_LIFE = "GET_ALL_LIFE"
export const STORED_PROPOSER_INSURER_DETAILS = "STORED_PROPOSER_INSURER_DETAILS"
